import React, { useEffect, useState } from "react";
import { Button } from "@jdcfe/legao";
import './style.scss';


export default function NoApp()  {
  const [ text, setText ] = useState("Hello, NoApp!");

  useEffect(()=> {
    document.title = '京东VOP开放平台-未创建应用';
  }, []);

  function handleClick() {
    return setText("Thanks, NoApp!");
  }

  return <Button onClick={handleClick}>{text}</Button>;
}